module.exports = __webpack_public_path__ + "static/media/icon_caret_right.a61987c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_caret_right.svg
// module id = 1056
// module chunks = 0